import { TableCell } from '@mui/material'
import React from 'react'

const RowNoFound = ({ colSpan = 0 }) => {
    return (
        <TableCell colSpan={colSpan} data-index={0} sx={{
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontStyle: 'normal',
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '2%',
            color: '#202020',
            overflowWrap: 'break-word'
        }}>No Records Found</TableCell>
    )
}

export default RowNoFound